import React, { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, Building2, Layers, Users, Inbox, Settings, Shield, LogOut, Menu, X } from "lucide-react";
import { OnyxWordmark } from "@/components/site/Brand";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/proposals", label: "Proposals", icon: FileText },
  { to: "/admin/projects", label: "Projects", icon: Building2 },
  { to: "/admin/services", label: "Services", icon: Layers },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/leads", label: "Leads", icon: Inbox },
  { to: "/admin/settings", label: "Settings", icon: Settings },
  { to: "/admin/access", label: "Access", icon: Shield },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = async () => { await logout(); navigate("/admin/login"); };

  const SidebarContent = () => (
    <>
      <div className="h-16 flex items-center px-6 border-b border-border"><OnyxWordmark /></div>
      <nav className="flex-1 p-3 space-y-1">
        {NAV.map((n) => (
          <NavLink
            key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)}
            data-testid={`sidebar-${n.label.toLowerCase()}`}
            className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-foreground text-background" : "text-muted-foreground hover:bg-secondary hover:text-foreground"}`}
          >
            <n.icon size={17} /> {n.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-border">
        <div className="flex items-center gap-3 px-3 py-2 mb-1">
          {user?.picture ? <img src={user.picture} alt="" className="w-8 h-8 rounded-full" /> : <div className="w-8 h-8 rounded-full bg-secondary" />}
          <div className="min-w-0"><div className="text-sm font-medium truncate">{user?.name}</div><div className="text-xs text-muted-foreground truncate">{user?.email}</div></div>
        </div>
        <button onClick={doLogout} data-testid="logout-btn" className="w-full flex items-center gap-3 px-3 py-2.5 text-sm text-muted-foreground hover:bg-secondary hover:text-foreground transition-colors"><LogOut size={17} /> Sign out</button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen bg-background text-foreground flex">
      <aside className="hidden lg:flex w-64 flex-col border-r border-border fixed inset-y-0 bg-card">{SidebarContent()}</aside>
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="w-64 bg-card flex flex-col">{SidebarContent()}</div>
          <div className="flex-1 bg-black/40" onClick={() => setOpen(false)} />
        </div>
      )}
      <div className="flex-1 lg:ml-64">
        <header className="lg:hidden h-16 border-b border-border flex items-center justify-between px-4 bg-card">
          <button onClick={() => setOpen(true)}><Menu /></button>
          <OnyxWordmark />
          <span className="w-6" />
        </header>
        <main className="p-5 md:p-8 max-w-[1500px]"><Outlet /></main>
      </div>
    </div>
  );
}
